// extracted by mini-css-extract-plugin
export default {"menuBlock":"_F-z","title":"aG-z","nav":"bG-z","flexCell":"cG-z","facetLink":"dG-z"};